import { CheckboxField, TextField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import Payouts from "containers/Payouts"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, formValueSelector, isDirty, reset } from "redux-form"

const PaymentTab = ({
  tax,
  paid,
  handleSave,
  tabIsActive,
  resetForm,
  isDirty,
  selectedSubCalendar,
  price,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <h4>PAYMENT</h4>
            </CardHeader>
            <CardBody>
              <Row>
                <Col>
                  <h5>Payment:</h5>
                </Col>
              </Row>
              <Row className="my-3">
                <Col
                  xs="auto"
                  xl={1}
                  style={{ minWidth: "fit-content" }}
                  className="mt-2"
                >
                  <Field
                    component={CheckboxField}
                    name="paid"
                    label="Paid($)"
                  />
                </Col>
                <Col xs="auto">
                  <Field
                    component={TextField}
                    name="price"
                    placeholder="Price($)"
                    disabled={!paid}
                    type="number"
                    min="0"
                    step="0.1"
                  />
                </Col>
              </Row>
              <Row className="my-4">
                <Col
                  xs="auto"
                  xl={1}
                  className="mt-2"
                  style={{ minWidth: "fit-content" }}
                >
                  <Field
                    component={CheckboxField}
                    name="tax"
                    label="Tax(%)"
                    disabled={!paid}
                  />
                </Col>
                <Col xs="auto">
                  <Field
                    component={TextField}
                    name="taxValue"
                    placeholder="Tax(%)"
                    disabled={!tax}
                    type="number"
                    min="0"
                    step="0.001"
                  />
                </Col>
              </Row>
              <Row>
                <Col
                  xs="auto"
                  xl={1}
                  className="align-self-center"
                  style={{ minWidth: "fit-content" }}
                >
                  <label>Tax Label</label>
                </Col>
                <Col sm={9} xl={6}>
                  <Field
                    component={TextField}
                    name="taxLabel"
                    placeholder="Tax Label"
                    disabled={!tax}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* <Row>
        <Col>
          {paid && (
            <Card>
              <CardHeader>
                <h4>Payouts</h4>
              </CardHeader>
              <CardBody>
                <Payouts
                  entity_id={selectedSubCalendar?.id}
                  entity_type="booking_type"
                  price={price}
                />
              </CardBody>
            </Card>
          )}
        </Col>
      </Row> */}
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.SUB_CALENDARS)

const mapStateToProps = state => ({
  tax: selector(state, "payment.tax"),
  paid: selector(state, "payment.paid"),
  price: selector(state, "payment.price"),
  isDirty: isDirty(FORM_NAMES.SUB_CALENDARS)(state, ...["payment"]),
  selectedSubCalendar: state.BookingsFeature.selectedSubCalendar,
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.SUB_CALENDARS)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PaymentTab)
